import { useStore } from "vuex"
import { ref, computed } from 'vue'
import { isDocument, getDocumentIcon } from "foundation/js/utils/communityAttachmentUtils"

export default {
    name: "AttachmentsEditor",
    props: {
        acceptedFileTypes: {
            type: String,
            required: false,
            default: ".doc, .docx, .xls, .xlsx, .pdf, .gif, .jpeg, .jpg, .tiff, .bmp, .png"
        },
        files: {
            type: Array,
            required: true,
            default: []
        },
        fileErrorMessage : {
            type: String,
            required: false,
            default: ''
        },
        maxAttachments: {
            type: Number,
            required: false,
        },
    },
    setup(props, { emit }) {
        const store = useStore()

        const MAX_FILE_SIZE_MB = 10 // Maximum file size in MB
        const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024 // Convert MB to bytes

        const isValidationError = ref(false)
        
        const fileIdCount = ref(0)
        const files = ref(props.files.map(file => {
            return {
                ...file,
                isOriginal: true
            }
        }))
        
        const filesToRemove = computed(() => props.files.filter(file => !files.value.some(f => f.id === file.id)).map(file => file.id))
        const filesToAdd = computed(() => files.value.filter(file => !file.isOriginal).map(file => file.file))
        
        const addFile = (e) => {
            clearValidationError()

            if (props.maxAttachments && props.maxAttachments < (e.target.files.length + files.value.length) ){
                return
            }

            const eventFiles = e.target.files
            Array.from(eventFiles).forEach(eventFile => {
                if (eventFile.size > MAX_FILE_SIZE_BYTES) {
                    isValidationError.value = true
                    return
                }
                
                const newFile = {
                    filename: eventFile.name,
                    size: eventFile.size,
                    id: fileIdCount.value++,
                    url: URL.createObjectURL(eventFile),
                    isOriginal: false,
                    file: eventFile
                }
                files.value.push(newFile)
            })
            
            emit('update:filesToAdd', filesToAdd.value)
        }
        
        const removeFile = (fileToRemove) => {
            clearValidationError()
            
            files.value = files.value.filter(file => file.id !== fileToRemove.id)
            emit('update:filesToAdd', filesToAdd.value)
            emit('update:filesToRemove', filesToRemove.value)
        }
        
        const clearValidationError = () => {
            isValidationError.value = false
        }
        
        const clear = () => {
            files.value = []
            emit('update:filesToAdd', filesToAdd.value)
            emit('update:filesToRemove', filesToRemove.value)
        }
        
        const formatFileSize = size => {
            if (typeof size === "string") {
                return size
            }
            
            const sizeKB = size / 1024
            
            if (sizeKB < 1000) {
                return `${sizeKB.toFixed(1)} KB`   
            }
            
            const sizeMB = sizeKB / 1000
            return `${sizeMB.toFixed(3)} MB`
        }
        
        const getLabel = (labelKey, allowEmpty = false) => 
            store.getters['labels/getLabel']({labelCollection: 'AttachmentsEditor', labelKey, allowEmpty})

        return {
            getLabel,
            formatFileSize,
            isValidationError,
            addFile,
            removeFile,
            clear,
            getDocumentIcon,
            isDocument,
            files
        }
    }
}